import UserService from "../../services/user.service";

const state = {
    userList: [],
    userRoles: [],
    permissions: [],
    userPermissions: [],
};

const mutations = {



    set_user_list(state, payload) {
        state.userList = payload
    },

    clear_user_list(state)
    {
        state.userList = []
    },

    set_user_roles(state, payload) {
        state.userRoles = payload;
    },

    clear_user_roles(state){
        state.userRoles = []
    },

    set_permissions(state, payload) {
        state.permissions = payload;
    },

    clear_permissions(state) {
        state.permissions = [];
    },

    set_user_permissions(state, payload) {
        state.userPermissions = payload;
        // console.log(payload)
    },

    clear_user_permissions(state)
    {
        state.userPermissions = [];
    }

};

const actions = {

    async getUsers({commit}) {

        await commit("clear_user_list");
        const users = await UserService.getUsersService();
        await commit("set_user_list", users);
        return users;
    },

    async getUserRoles({commit}) {
        await commit("clear_user_roles");
        const usersRoles = await UserService.getUserRolesService(); //
        await commit("set_user_roles", usersRoles);
        return usersRoles;
    },

    async setUserRole({dispatch}, payload) {
        const setUserRole = await UserService.setUserRoleService(payload);
        await dispatch("getUsers");
        return setUserRole;
    },

    async setUserActive({dispatch}, payload) {
        const setUserActive = await UserService.setUserActiveService(payload);
        await dispatch("getUsers");
        return setUserActive;
    },

    async getPermissions({commit}) {
        await commit("clear_permissions");
        const permissions = await UserService.getPermissionsService();//
        await commit("set_permissions", permissions);
        return permissions;
    },

    async getUserPermissions({commit}, payload) {
        await commit("clear_user_permissions");
        const userPermissions = await UserService.getUserPermissionsService(payload); //
        await commit("set_user_permissions", userPermissions);
        return userPermissions;
    },

    async setUserPermission({dispatch}, payload) {

        const setUserPermission = await UserService.setUserPermissionService(payload);
        dispatch("getPermissions");
        dispatch("getUserPermissions",payload.UserId);
        return setUserPermission;
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
